import { createApp } from 'vue'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import { plugin, defaultConfig, createInput } from '@formkit/vue'
import { createAutoAnimatePlugin } from '@formkit/addons'
import { en, fr } from '@formkit/i18n'
import { createPinia } from 'pinia'
import isValidFrNumber from './custom-rules/is-fr-number'
import VueSweetalert2 from 'vue-sweetalert2'
import App from './App.vue'
import PhoneInput from './components/PhoneInput.vue'
import 'sweetalert2/dist/sweetalert2.min.css'

const pinia = createPinia()

const app = createApp(App)

app.use(autoAnimatePlugin)
app.use(
  plugin,
  defaultConfig({
    config: {
      classes: {
        input: 'smdt-input',
      },
    },
    plugins: [createAutoAnimatePlugin()],
    rules: { isValidFrNumber },
    inputs: {
      fhone: createInput(PhoneInput),
    },
  locales: { en, fr },
  // Define the active locale
  locale: devisObject.langCode,
  })
)
app.use(pinia)
app.use(VueSweetalert2, {
  confirmButtonColor: '#E2001A',
})
// eslint-disable-next-line no-undef
app.config.globalProperties.vals = { ...devisObject } // vals is values got by wp_localise
app.mount('#devis')
